import ReviewsRatingWidget from './ReviewsRatingWidget';
import { RootState } from '../../store/store.types';

type ProductTitleProps = {
  productName: string;
  productDetails: RootState['product']['data']['details'];
};

const ProductTitle = ({ productName, productDetails }: ProductTitleProps) => (
  <div className="pdp-atf-title product-title">
    <div className="pdp-details-title">
      <h2 className="h3">{productName}</h2>
    </div>
    {productDetails?.sku && (
      <ReviewsRatingWidget sku={productDetails.sku} />
    )}
  </div>
);

export default ProductTitle;
